<div class="invalid-configuration-container">
    <div class="modal custom-container">
        <div class="header">
            <div class="smash-logo">
                <i class="icon-smash_icologo_chip"></i>
            </div>
            <h1>
                {{ 'MODAL_INVALID_CONFIGURATION_TITLE' | translate }}
            </h1>
        </div>
        <div class="body">
            <div class="section">
                <div class="description">
                    {{ 'MODAL_INVALID_CONFIGURATION_DESCRIPTION' | translate }}
                </div>
            </div>
            <div class="section">
                <button class="btn primary" (click)="retry()"> {{ 'MODAL_INVALID_CONFIGURATION_BUTTON_LABEL_ACTION_RETRY' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
